import type { PropsWithChildren } from 'react';
import type React from 'react';
import { useContext } from 'react';
import { TopLayerContext } from '../../TopLayer/TopLayerContext';
import Button, { Size } from '../../Button/Button';

export interface SideBarHeaderProps {
  headerText?: string;
}

const SideBarHeader: React.FC<PropsWithChildren<SideBarHeaderProps>> = ({
  children,
  headerText,
}) => {
  const { closeTopLayerElement } = useContext(TopLayerContext);

  return (
    <header className="drawer-header">
      {headerText && <h4>{headerText}</h4>}
      <Button
        onClick={closeTopLayerElement}
        isClean
        icon="fa-xmark"
        aria-label="close-sidebar"
        size={Size.xs}
        className={'drawer-header-button'}
      />
      {children}
    </header>
  );
};
export default SideBarHeader;
